import { useCallback, useEffect, useState } from "react";
import { UserRoleService } from "../services/UserRoleService";

export const useHookUserRole = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try{
            const res = await UserRoleService.get();
            setData(res.data.data);
        }catch(err){
            setError(err);
            throw err;
        }finally{
            setLoading(false);
        }
    }, []);

    useEffect(()=>{
        getData();
    },[getData]);

    return {
        data,
        loading,
        error,
        refreshData: () => getData()
    }
}